/**
 * SupabaseLeadRepository
 * 
 * Responsabilidade: Orquestração de operações de persistência de Leads
 * Padrão: Facade - delega para módulos especializados
 * 
 * Princípios:
 * - Single Responsibility: apenas orquestração
 * - Dependency Inversion: implementa ILeadRepository
 * - Separation of Concerns: queries, persistência, validação e mapeamento separados
 */

import { ILeadRepository } from '../../domain/repositories/ILeadRepository';
import { Lead } from '../../domain/entities/Lead';
import { LeadQueries } from './queries/LeadQueries';
import { LeadStatsQueries } from './queries/LeadStatsQueries';
import { LeadPersistence } from './persistence/LeadPersistence';

export class SupabaseLeadRepository implements ILeadRepository {
    async findAll(organizationId?: string): Promise<Lead[]> {
        return LeadQueries.findAll(organizationId);
    }

    async findById(id: string): Promise<Lead | null> {
        return LeadQueries.findById(id);
    }

    async findByStage(stageId: string): Promise<Lead[]> {
        return LeadQueries.findByStage(stageId);
    }

    async findByFunnel(funnelId: string, organizationId?: string): Promise<Lead[]> {
        return LeadQueries.findByFunnel(funnelId, organizationId);
    }

    async findByAgent(agentName: string, organizationId?: string): Promise<Lead[]> {
        return LeadQueries.findByAgent(agentName, organizationId);
    }

    async findHighValue(organizationId?: string): Promise<Lead[]> {
        return LeadStatsQueries.findHighValue(organizationId);
    }

    async findStale(organizationId?: string): Promise<Lead[]> {
        return LeadStatsQueries.findStale(organizationId);
    }

    async save(lead: Lead, organizationId?: string): Promise<string | undefined> {
        return LeadPersistence.save(lead, organizationId);
    }

    async delete(id: string): Promise<void> {
        return LeadPersistence.delete(id);
    }

    async count(organizationId?: string): Promise<number> {
        return LeadStatsQueries.count(organizationId);
    }

    async countByStage(stageId: string): Promise<number> {
        return LeadStatsQueries.countByStage(stageId);
    }
}
